module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-main"
  }, [_c('div', {
    staticClass: "tab-con"
  }, [_c('router-link', {
    attrs: {
      "to": '/' + '?hideNav=1'
    }
  }, [_c('span', {
    attrs: {
      "href": "javascript:;",
      "data-track": "djk_kwys_wdfw_tab_tw_click"
    }
  }, [_vm._v("提问")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/lists/' + '?hideNav=1'
    }
  }, [_c('span', {
    staticClass: "on",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("服务历史")])])], 1), _vm._v(" "), (!_vm.noData) ? [_c('div', {
    staticClass: "page-services page-scrollview",
    attrs: {
      "id": "scrollview"
    }
  }, [_c('InfiniteScroll', {
    attrs: {
      "onInfinite": _vm.loadList
    }
  }, [_c('div', {
    staticClass: "list",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.questionLists), function(item, index) {
    return _c('Question', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "status": item.status,
        "data-track": "djk_kwys_wdfw_question_click"
      },
      nativeOn: {
        "click": function($event) {
          _vm.getPay(item, $event)
        }
      }
    })
  })), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "doneTip"
    },
    slot: "doneTip"
  }, [_vm._v("没有数据啦~~")]), _vm._v(" "), _c('img', {
    attrs: {
      "slot": "loadingTip",
      "src": require("../assets/loading.svg")
    },
    slot: "loadingTip"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-bar border5"
  }, [_c('Btn', {
    attrs: {
      "size": "large",
      "type": "primary",
      "track": "yy_djk_kwys_jxtw"
    },
    nativeOn: {
      "click": function($event) {
        _vm.goQuestion($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnText))])], 1), _vm._v(" "), (!_vm.supportShubi) ? _c('div', {
    staticClass: "popup popup-pay"
  }, [_c('Popup', {
    attrs: {
      "position": "bottom",
      "width": "100%",
      "height": "auto"
    },
    model: {
      value: (_vm.isPay),
      callback: function($$v) {
        _vm.isPay = $$v
      },
      expression: "isPay"
    }
  }, [_c('h3', [_vm._v("支付方式")]), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, [_c('ul', _vm._l((_vm.payList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "border4"
    }, [_c('i', {
      staticClass: "icon",
      class: 'icon-' + item.payWayType
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "btn-select",
      class: item.id === _vm.paywayid ? 'on' : '',
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.select(item.id)
        }
      }
    })])
  })), _vm._v(" "), _c('Btn', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pay($event)
      }
    }
  }, [_vm._v("确认支付")])], 1), _vm._v(" "), _c('a', {
    staticClass: "btn-close border-blue",
    attrs: {
      "href": "javascript:;",
      "data-track": "djk_kwys_ym_wdfw_zfgb"
    },
    on: {
      "click": function($event) {
        _vm.isPay = false
      }
    }
  }, [_vm._v("X")])])], 1) : _c('payComp', {
    ref: "payComp",
    attrs: {
      "oldPrice": _vm.price,
      "orderCode": _vm.orderCode
    },
    on: {
      "paySuccess": _vm.paySuccess
    }
  })] : _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/images/no-data.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无服务")]), _vm._v(" "), _c('div', [_vm._v("购买过的服务将显示在这里")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.goQuestion($event)
      }
    }
  }, [_c('span', [_vm._v("立即提问")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "popup popup-protocol"
  }, [_c('Popup', {
    attrs: {
      "position": "bottom",
      "width": "100%",
      "height": "100%"
    },
    model: {
      value: (_vm.isProtocol),
      callback: function($$v) {
        _vm.isProtocol = $$v
      },
      expression: "isProtocol"
    }
  }, [_c('h3', [_vm._v("用户协议")]), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, [_c('div', [_c('p', [_vm._v("“快问医生”使用规则")]), _vm._v(" "), _c('p', [_vm._v("“快问医生”为您和医生之间的付费健康咨询平台。在您向医生支付咨询费用前，请详细阅读本使用规则。")]), _vm._v(" "), _c('h4', [_vm._v("一、服务")]), _vm._v(" "), _c('p', [_vm._v("1、本服务所称“咨询”特指您通过“快问医生”提交问题并支付费用后，“快问医生”将您提交的问题随机分配给“快问医生”合作方的医生（ 以下简称“医生”），由医生认领问题并进行回复。")]), _vm._v(" "), _c('p', [_vm._v("2、在您提交问题时以及与医生对话过程中，请您不要披露您的真实个人信息，如您仍披露的，视为您同意披露；并且您提交问题时发布的文字或图片，系统指定医生可查看，如您不同意的，请您立即停止提交问题。")]), _vm._v(" "), _c('p', [_vm._v("3、每一问题，您发言后医生进行回复计为一次对话，您可在提交问题后【24】小时内与医生进行20次对话。请您特别注意，您提交的问题将在您提问已满【24】小时后（自您提交问题之时起算【24】小时）或您与医生已进行20次对话后关闭。")]), _vm._v(" "), _c('p', [_vm._v("4、如对话过程中，您偏离问题或者发言不符合言行要求，医生有权提醒您改正（此种情形下，医生的提醒视为医生回复），如您不改正的，医生有权【拒绝回复直至问题关闭】。")]), _vm._v(" "), _c('p', [_vm._v("5、您提交问题并支付费用，视为您向医生发出了不可撤销的合同要约，医生第一次回复时，方视为医生与您之间建立了合同关系；您了解并知悉，医生有完全的、自主的权利决定是否就您的问题进行第一次答复，如您提交问题后，超过1小时没有医生第一次回复，“快问医生”将在1-3个工作日内向您原路退还您已经支付的费用。")]), _vm._v(" "), _c('p', [_vm._v("6、建议您根据实际情况描述问题，并辅助图片说明，这样将提高您的问题获得医生第一次回复的机会。")]), _vm._v(" "), _c('p', [_vm._v("7、您了解医生仅能尽可能利用专业知识及临床经验给予您一定的解惑及帮助建议，不进行诊断或治疗，同时不对答复是否符合您的预期做保证。除另有明确说明外，您不得因为咨询服务中的内容不满意要求退款。")]), _vm._v(" "), _c('h4', [_vm._v("二、费用")]), _vm._v(" "), _c('p', [_vm._v("1、每次咨询将收取您一定的费用，请您在付费前注意查看费用金额、使用提示等并审慎选择。")]), _vm._v(" "), _c('p', [_vm._v("2、您不可撤销地授权宝宝树代为收取您支付给医生的咨询费用，宝宝树将在咨询结束后按照与合作方的相关协议向合作方或医生支付费用。")]), _vm._v(" "), _c('p', [_vm._v("3、您了解并知悉，除另有明确说明外，任何情况下您均不得要求退款。")]), _vm._v(" "), _c('h4', [_vm._v("三、权利义务")]), _vm._v(" "), _c('p', [_vm._v("1、如您对咨询不满意的，可向宝宝树提出投诉。")]), _vm._v(" "), _c('p', [_vm._v("2、如您与医生发生服务纠纷的，您可通过司法部门或行政部门依照法定程序要求宝宝树提供相关数据，宝宝树应积极配合并提供有关资料。")]), _vm._v(" "), _c('p', [_vm._v("3、在咨询过程中您发布的内容或提问必须遵守中国法律法规、行政规章以及规范性文件、遵守宝宝树公布的所有服务协议，并不得有以下行为：")]), _vm._v(" "), _c('p', [_vm._v("（1）发布以下内容：煽动抗拒、破坏宪法及法律法规实施的言论；煽动颠覆国家政权、破坏国家统一的言论；违背社会风俗和社会道德的言论；煽动民族仇恨、民族歧视，破坏民族团结的言论； ")]), _vm._v(" "), _c('p', [_vm._v("（2）发布使用任何侮辱或毁谤他人，性骚扰，或对未成年人有不良影响的内容；")]), _vm._v(" "), _c('p', [_vm._v("（3）发布淫秽、色情、赌博、暴力、凶杀、恐怖、非法宗教或者教唆犯罪的内容； ")]), _vm._v(" "), _c('p', [_vm._v("（4）发布广告等牟利性经营活动的内容；")]), _vm._v(" "), _c('p', [_vm._v("（5）发布侵犯第三方权利，特别是他人著作权、商标权等知识产权或者合法权利的内容；")]), _vm._v(" "), _c('p', [_vm._v("（6）发布要求医生进行诊断或治疗的内容；")]), _vm._v(" "), _c('p', [_vm._v("（7）其他根据宝宝树平台性质，不适宜发布的内容。")]), _vm._v(" "), _c('p', [_vm._v(" 如您违反的，宝宝树有权视情况选择以下一种或几种措施：")]), _vm._v(" "), _c('p', [_vm._v("（1）立即对相应信息进行删除、屏蔽；")]), _vm._v(" "), _c('p', [_vm._v("（2）中止向您提供部分或全部服务；")]), _vm._v(" "), _c('p', [_vm._v("（3）查封您的账户，终止向您提供服务；")]), _vm._v(" "), _c('p', [_vm._v("（4）要求您赔偿损失（包括宝宝树自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿宝宝树的上述全部损失。")]), _vm._v(" "), _c('p', [_vm._v("3、您在咨询过程中应语言文明，尊重医生，平等交流。如有对医生恶意中伤，语言不文明，医生有权【拒绝回复直至问题关闭】，您无权要求退款。")]), _vm._v(" "), _c('h4', [_vm._v("四、免责")]), _vm._v(" "), _c('p', [_vm._v("1、咨询中医生所提供内容均是个人建议，不得做为诊断、治疗的直接医疗处置依据，用户需知晓并同意诊断及治疗均需前往医院。擅自将医生建议做为处方使用的，后果自负。是否采信咨询中医生的意见为您的个人行为，“快问医生”及宝宝树不承担任何可能产生的责任。")]), _vm._v(" "), _c('p', [_vm._v("2、“快问医生”有权对您的注册数据及咨询的行为进行查阅，发现注册数据或咨询行为中存在任何问题或合理怀疑，均有权向您发出询问及要求改正的通知或者直接作出删除等处理。")]), _vm._v(" "), _c('p', [_vm._v("3、对于您在使用“快问医生”中的不当行为或其它任何“快问医生”认为应当终止服务的情况，“快问医生”有权随时作出删除相关信息、终止服务提供等处理，而无须征得您的同意。")])])]), _vm._v(" "), _c('a', {
    staticClass: "btn-close border-blue",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closeProtocol
    }
  }, [_vm._v("X")])])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75e36cc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Service.vue
// module id = 604
// module chunks = 1